import { useState } from 'react';

export const useContact = () => {
    const [isContactFormOpen, setIsContactFormOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [contactData, setContactData] = useState({});

    const openContactForm = (inquiryType, prefilledData = {}) => {
        setContactData({ inquiryType, prefilledData });
        setIsContactFormOpen(true);
    };

    const closeContactForm = () => {
        setIsContactFormOpen(false);
        setContactData({});
    };

    const handleContactSuccess = () => {
        setIsContactFormOpen(false);
        setIsSuccessModalOpen(true);
    };

    const closeSuccessModal = () => {
        setIsSuccessModalOpen(false);
    };

    return {
        isContactFormOpen,
        isSuccessModalOpen,
        contactData,
        openContactForm,
        closeContactForm,
        handleContactSuccess,
        closeSuccessModal,
    };
};